import { call, takeLatest } from "redux-saga/effects";
import { API_URL, SAGA_ACTIONS, sagaFunction } from "../_config";
import { CallApi } from "./api/callApi";

function* getSignalHireCredits(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.SIGNALHIRE.CREDITS, action.payload, true);
}

function* getSignalHireUtilization(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.SIGNALHIRE.UTILIZATION, action.payload, true);
}

function* getSignalHireCompanyLogs(action: any): any {
  const { companyId, ...params } = action.payload || {};
  const url = API_URL.SIGNALHIRE.COMPANY_LOGS(companyId);
  yield call(sagaFunction, action, CallApi.GET, url, params, true);
}

export default function* adminSignalHireSaga() {
  yield takeLatest(SAGA_ACTIONS.ADMIN.SIGNALHIRE.CREDITS, getSignalHireCredits);
  yield takeLatest(SAGA_ACTIONS.ADMIN.SIGNALHIRE.UTILIZATION, getSignalHireUtilization);
  yield takeLatest(SAGA_ACTIONS.ADMIN.SIGNALHIRE.COMPANY_LOGS, getSignalHireCompanyLogs);
}
